


const variantMap = {
  default: 'bg-slate-100 text-slate-600',
  teal: 'bg-teal-50 text-teal-700',
  amber: 'bg-amber-50 text-amber-700',
  rose: 'bg-rose-50 text-rose-600',
  emerald: 'bg-emerald-50 text-emerald-700',
  slate: 'bg-slate-800 text-slate-200',
};

const sizeMap = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-xs px-2.5 py-1',
};

export default function Badge({ label, variant = 'default', size = 'md', icon }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap ${variantMap[variant]} ${sizeMap[size]}`}>
      {icon && <i className={`${icon} text-xs`} />}
      {label}
    </span>
  );
}

export function ScoreBadge({ score }) {
  const label = score >= 80 ? 'Distinction' : score >= 50 ? 'Pass' : 'Poor';
  const styleMap = {
    Distinction: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Pass: 'bg-amber-50 text-amber-700 border border-amber-200',
    Poor: 'bg-rose-50 text-rose-600 border border-rose-200',
  };
  const iconMap = {
    Distinction: 'ri-medal-line',
    Pass: 'ri-checkbox-circle-line',
    Poor: 'ri-close-circle-line',
  };
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${styleMap[label]}`}>
      <i className={iconMap[label]} />
      {label}
    </span>
  );
}
